export default class Price {

    constructor(amount, currency = null) {
        this.amount = amount ? parseFloat(amount) : 0;
        this.taxRate = 1;

        this.currency = currency ? currency : {
            iso_code: '',
            name: '',
            symbol: '',
            symbol_placement: ''
        };
    }

    add(amount) {
        this.amount += amount ? parseFloat(amount) : 0;
    }

    getNet(multiplier = 1) {
        return this.amount * multiplier;
    }

    getGross(multiplier = 1) {
        return this.amount * multiplier * this.taxRate;
    }

    getNetFormatted(multiplier = 1) {
        return Intl.NumberFormat('pl-PL', {style: 'currency', currency: this.currency.iso_code}).format(this.getNet(multiplier));
    }

    getGrossFormatted(multiplier = 1) {
        return Intl.NumberFormat('pl-PL', {style: 'currency', currency: this.currency.iso_code}).format(this.getGross(multiplier));
    }
}
